const zh_tw = require("./apexLocales/zh-tw.json");
import constJs from '../const.js';

export default class CONST {
  static realTimePeopleFlowIndex = { //bar版本
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
      type: "bar",
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      // curve: "smooth",
      dashArray: 0,
    },
    title: {
      text: "人數",
      align: "left",
    },
    legend: {
      // tooltipHoverFormatter: function (val, opts) {
      //   return (
      //     val +
      //     " - " +
      //     opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //     ""
      //   );
      // },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      type: "datetime",
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              day: "MM/dd",
              hour: "HH",
            },
          },
          tooltip:{
            enabled: false
          },

      categories: [
      ],
    },
    tooltip: {
      x: {
        format: "MM/dd HH",
        formatter:undefined
      },
      y: [
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        },
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }
  static realTimePeopleFlow = {
    colors: constJs.APEXCHART_COLOR.SCENIC_AREA,
    chart: {
      defaultLocale: 'zh-tw',
      // height: 300,
      type: "area",
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      curve: "smooth",
      dashArray: 0,
    },
    title: {
      text: "人數",
      align: "left",
    },
    legend: {
        onItemClick: {
          toggleDataSeries: false
        }

    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      type: "datetime",
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              day: "MM/dd",
              hour: "HH",
            },
          },
          tooltip:{
            enabled: false
          },

      categories: [
      ],
    },
    tooltip: {
      x: {
        format: "MM/dd HH",
        formatter:undefined
      },
      y: {
        formatter:undefined,
       
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  static sumPeopleFlow = {
    colors: constJs.APEXCHART_COLOR.SCENIC_AREA,
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
      type: "area",
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      curve: "smooth",
     
    },
    title: {
      text: "進場人數",
      align: "left",
    },
    legend: {
        onItemClick: {
          toggleDataSeries: false
        },
      // tooltipHoverFormatter: function (val, opts) {
      //   return (
      //     val +
      //     " - " +
      //     opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //     ""
      //   );
      // },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    fill:{
      opacity:0.1
    },
    xaxis: {
      type: "category",
      tooltip:{
        enabled: false
      },
          // labels: {
          //   datetimeUTC: false,
          //   datetimeFormatter: {
          //     month: "yyyy/MM",
          //     day: "dd",
          //   },
          // },
      categories: [
      ],
    },
    tooltip: {
      x: {
        format: "yyyy/MM",
        formatter:undefined,
      },
      y: {
        formatter:undefined
    },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  static sumPeopleFlowMonth = {
    colors: constJs.APEXCHART_COLOR.SCENIC_AREA,
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
      type: "area",
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
      dashArray: 0,
    },
    title: {
      text: "進場人數",
      align: "left",
    },
    legend: {
        onItemClick: {
          toggleDataSeries: false
        }

      // tooltipHoverFormatter: function (val, opts) {
      //   return (
      //     val +
      //     " - " +
      //     opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //     ""
      //   );
      // },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      type: "category",
      tooltip:{
        enabled: false
      },
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: "yyyy",
              month: "MM",
            },
          },

      categories: [
      ],
    },
    tooltip: {
      x: {
        
      },
      y: {
        formatter:undefined
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  static sumPeopleFlowYear = {
    colors: constJs.APEXCHART_COLOR.SCENIC_AREA,
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
      // type: "line",
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
      dashArray: 0,
    },
    title: {
      text: "進場人數",
      align: "left",
    },
    legend: {
        onItemClick: {
          toggleDataSeries: false
        }
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      type: "categories",
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: "yyyy",
            },
          },
      tooltip:{
          enabled: false
        },
      categories: [
      ],
    },

    // fill:{
    //   opacity:0,
    // },
    tooltip: {
      x: {
        format: "yyyy",
      },
      y: {
        undefined
      }
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  static crossCenterOption = {
    chart: {
      defaultLocale: 'zh-tw',
      type: 'bar',
      stacked: true,
      height: 350,
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    colors: ['#00ae9a'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '25%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      type: 'category',
      categories: [],
    },
    yaxis: {
      title: {
        text: '進場人數'
      }
    },
    fill: {
      opacity: 0.8,

    },
    tooltip: {
      y: {
        formatter: function (val) {
          return  val + "位"
        }
      }
    }
} 
}